<script>

  export default {
    components: {},
    props: {
      planotrabalhoaquisicoes: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
    },
    computed: {
    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th></th>
            <th style="width:45%">Produto</th>
            <th style="width:45%">Complemento</th>
            <th style="width:10%">Quantidade</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(aquisicao, index) in planotrabalhoaquisicoes.registros">
            <td></td>
            <td>{{ aquisicao.produto || '---' }}</td>
            <td>{{ aquisicao.complemento || '---' }}</td>
            <td>{{ aquisicao.quantidade  | formatarNumero }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/compartilhado/FormPlanoTrabalhoAquisicoes.vue